module.exports = __webpack_public_path__ + "static/media/TAN35.dcf691ac.jpeg";